exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  font-family: sans-serif;\n  margin: 0;\n  padding: 0; }\n\n.alert {\n  margin: 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/css/index.scss
// module id = 111
// module chunks = 0